import { STRINGS } from '../auth.strings';

export function getTitleByPathName(pathname: string) {
  const titleMappings = {
    '/residents': STRINGS['enter_contact.resident-title'],
    '/homes': STRINGS['enter_contact.resident-title'],
    '/homeowners': STRINGS['enter_contact.homeowner-title'],
  };

  const matchingPath = (
    Object.keys(titleMappings) as (keyof typeof titleMappings)[]
  ).find((key) => pathname.startsWith(key));

  // `matchingPath &&` reproduces the previous `titleMappings[undefined]`,
  // which was `undefined` and fell through to the generic title.
  return (
    (matchingPath && titleMappings[matchingPath]) ||
    STRINGS['enter_contact.generic-title']
  );
}
